const styles = (theme) => ({
  infoTitle: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "16px",
    color: theme.dispatchPanelHeaderColor,
    flexShrink: 0,
  },
  infoValue: {
    fontSize: theme.textFontSize,
    fontWeight: 500,
    lineHeight: "16px",
    color: theme.dispatchPanelLabelValueColor,
    wordBreak: "break-word",
  },
  infoContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4,
    padding: "8px 16px",
    marginTop: 12,
  },
  infoRow: {
    padding: "8px 0",
  },
  sectionTitle: {
    color: theme.palette.primary.main,
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    fontWeight: 600,
  },
  sectionInfo: {
    color: theme.dispatchPanelHeaderColor,
    lineHeight: "19px",
    fontWeight: 400,
    fontSize: theme.headerTextFontSize,
  },
  rightPanelInfoSection: {
    flexDirection: "row",
    display: "flex",
    padding: "8px 0",
  },
  infoPadding: {
    padding: " 0 12px",
  },
});

export default styles;
